<template>
  <LoadingComponent v-if="loading" />
  <template v-else-if="!loading && localDashboard">
    <div class="shrink-0">
      <DashboardHeader :dashboard="localDashboard">
        <template #cta>
          <BaseButton
            v-if="$can('manage_invoicing')"
            :title="$t('button.add_order')"
            color="warning"
            icon="plus"
            size="small"
            @click="addNewSupplierOrder"
          />
          <DashboardPanelControl
            v-model:dashboard="localDashboard"
            v-model:require-save-dashboard="requireSaveDashboard"
            :need-save-locked="loading"
            :count-filter="validFilter.length ?? 0"
            @dashboard-changed="dashboardChanged"
          >
            <template #filter-content="{ close }">
              <FilterLinesComponent
                v-model:filters="localDashboard.filters"
                v-model:require-save-dashboard="requireSaveDashboard"
                :filters-available="availableFilter"
                @close-popover="() => closePopover(close)"
              />
            </template>
          </DashboardPanelControl>
        </template>
      </DashboardHeader>
    </div>
    <div class="min-h-0 flex-1">
      <SupplierOrdersContainer
        :supplier-orders="supplier_orders"
        :metadata="metadata"
        @fetch-supplier-orders="fetchSupplierOrders"
      />
    </div>
  </template>
  <SupplierOrderModal
    v-model:open="isSupplierOrderModalOpen"
    :supplier-order-id="null"
  />
</template>

<script>
import LoadingComponent from '@c/TheLoadingComponent.vue'
import DashboardPanelControl from '@c/Dashboard/Components/DashboardPanelControl.vue'
import FilterLinesComponent from '@c/Dashboard/Components/FilterLinesComponent.vue'
import DashboardHeader from '@c/Dashboard/Components/DashboardHeader.vue'
import { mapActions, mapGetters } from 'vuex'
import SupplierOrdersContainer from '@c/Dashboard/Content/SupplierOrder/components/SupplierOrdersContainer.vue'
import SupplierOrderModal from '@ui/modal/supplierOrder/SupplierOrderModal.vue'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'

export default {
  name: 'SupplierOrderContent',
  components: {
    BaseButton,
    SupplierOrderModal,
    SupplierOrdersContainer,
    LoadingComponent,
    DashboardPanelControl,
    FilterLinesComponent,
    DashboardHeader
  },
  props: {
    currentBoard: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      localDashboard: null,
      loading: false,
      isSupplierOrderModalOpen: false,
      supplier_orders: [],
      metadata: [],
      supplierOrder: null,
      requireSaveDashboard: false
    }
  },
  computed: {
    ...mapGetters({
      availableFilter: 'metadata/getAvailableFilterSupplierOrder'
    }),
    validFilter() {
      return (
        this.localDashboard.filters?.filter(
          (filter) => filter.column && filter.values && filter.condition
        ) ?? []
      )
    }
  },
  watch: {
    currentBoard(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loading = true
        this.localDashboard = newValue
        this.fetchSupplierOrderDashboardConfig()
      }
    }
  },
  watch: {
    isSupplierOrderModalOpen(newValue, oldValue) {
      if (newValue !== oldValue && newValue === false) {
        this.fetchSupplierOrders()
      }
    }
  },
  mounted() {
    this.fetchSupplierOrderDashboardConfig()
  },
  methods: {
    ...mapActions({
      processFetchTemplateDashboardByIdAction:
        'dashboard/fetchTemplateDashboardById',
      processFetchAllSupplierOrdersAction:
        'supplierOrder/fetchAllSupplierOrders',
      processFetchNewSupplierOrderAction: 'invoicing/fetchNewSupplierOrder'
    }),
    addNewSupplierOrder() {
      this.isSupplierOrderModalOpen = true
    },
    fetchSupplierOrders: function () {
      let params = {
        filters: this.validFilter
      }
      this.processFetchAllSupplierOrdersAction(params).then((response) => {
        this.supplier_orders = response.supplier_orders
        this.metadata = response.metadata
      })
    },
    fetchSupplierOrderDashboardConfig() {
      this.loading = true
      const targetId = this.currentBoard.id
      this.processFetchTemplateDashboardByIdAction({ id: targetId })
        .then((response) => {
          if (this.currentBoard.id !== targetId) return
          this.localDashboard = response.template_dashboard
          this.fetchSupplierOrders()
        })
        .catch((error) => {
          this.$router.push({ name: 'dashboard_main_page_route' })
        })
        .finally((_) => {
          if (this.currentBoard.id === targetId) this.loading = false
        })
    },
    closePopover(close) {
      if (typeof close === 'function') {
        close()
      }
      this.fetchSupplierOrders()
    },
    dashboardChanged(_dashboard_template_id) {
      this.fetchSupplierOrderDashboardConfig()
    }
  }
}
</script>
